import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, createElementBlock as _createElementBlock, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 2,
  class: "container-fluid",
  style: {"margin-top":"80px","padding-top":"40px"}
}
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col-lg-6 d-flex align-items-end" }
const _hoisted_4 = { class: "project-title" }
const _hoisted_5 = { class: "project-title-link" }
const _hoisted_6 = { class: "col-lg-6 text-right align-self-end" }
const _hoisted_7 = { class: "dropdown d-inline" }
const _hoisted_8 = {
  class: "dropdown-menu dropdown-menu-right",
  style: {"max-height":"300px","overflow-y":"auto"}
}
const _hoisted_9 = {
  key: 0,
  class: "text-muted px-4 mb-1 font-italic d-block"
}
const _hoisted_10 = ["onClick"]
const _hoisted_11 = { key: 0 }
const _hoisted_12 = { key: 0 }
const _hoisted_13 = { class: "dropdown d-inline" }
const _hoisted_14 = {
  class: "dropdown-menu dropdown-menu-right",
  style: {"max-height":"300px","overflow-y":"auto"}
}
const _hoisted_15 = {
  key: 0,
  class: "text-muted px-4 mb-1 font-italic d-block"
}
const _hoisted_16 = ["onClick"]
const _hoisted_17 = { key: 1 }
const _hoisted_18 = { class: "table table-bordered table-hover" }
const _hoisted_19 = { key: 0 }
const _hoisted_20 = { class: "text-primary" }
const _hoisted_21 = { class: "text-center" }
const _hoisted_22 = { class: "text-center" }
const _hoisted_23 = { class: "text-center" }
const _hoisted_24 = { class: "text-center" }
const _hoisted_25 = { class: "text-center" }
const _hoisted_26 = { class: "text-center" }
const _hoisted_27 = { class: "text-center" }
const _hoisted_28 = { class: "text-center" }
const _hoisted_29 = { class: "btn-group" }
const _hoisted_30 = { class: "dropdown-menu dropdown-menu-right" }
const _hoisted_31 = ["disabled"]
const _hoisted_32 = ["disabled"]
const _hoisted_33 = {
  key: 1,
  class: "table-secondary"
}
const _hoisted_34 = { class: "text-primary" }
const _hoisted_35 = { class: "text-center" }
const _hoisted_36 = { class: "text-center" }
const _hoisted_37 = { class: "text-center" }
const _hoisted_38 = { class: "text-center" }
const _hoisted_39 = { class: "text-center" }
const _hoisted_40 = { class: "text-center" }
const _hoisted_41 = { class: "text-center" }
const _hoisted_42 = { class: "text-center" }
const _hoisted_43 = { class: "btn-group" }
const _hoisted_44 = { class: "dropdown-menu dropdown-menu-right" }
const _hoisted_45 = ["disabled", "onClick"]
const _hoisted_46 = ["onClick"]
const _hoisted_47 = ["onClick"]
const _hoisted_48 = ["onClick"]
const _hoisted_49 = ["onClick"]
const _hoisted_50 = ["onClick"]
const _hoisted_51 = ["disabled", "onClick"]

import { computed, shallowReactive, onMounted, watch, ref } from 'vue'
    import { useRoute } from 'vue-router'
    import moment from 'moment'

    import { generateName } from '@common/Common'
    import { guid } from '@common/Guid'

    import PortfolioNavigation from '@common/Components/PortfolioNavigation.vue'
    import Navigation from '@common/Navigation.vue'
    import ProjectNavigation from '@Quest/ProjectPlans/Components/ProjectNavigation.vue'
    import ProjectPlanEditor from '@Quest/ProjectPlans/Components/ProjectPlanEditor.vue'

    import { useManageProjectPlansPageQueryV1 } from '@Quest/ProjectPlans/queries-vue-composables'

    import
    {
        useCreateProjectPlanCommandV1,
        useCloneProjectPlanCommandV1,
        useDeleteProjectPlanCommandV1,
        useExportProjectPlanCommandV1,
        useSubmitProjectPlanCommandV1,
        useUnsubmitProjectPlanCommandV1,
        useUpdateProjectPlanCommandV1,
        useCreatePlanFromTemplateCommandV1
    } from '@Quest/ProjectPlans/commands-vue-composables'

    import { useUpdateProjectActivePlanCommandV1 } from '@Quest/Projects/commands-vue-composables'
    import { useCreateEnterpriseTemplateFromProjectPlanCommandV1 } from '@Quest/ProjectPlanTemplates/commands-vue-composables'

    import type { ManageProjectPlansPageReadModel, ProjectPlanReadModel } from '@Quest/ProjectPlans/readmodels'
    import type { ProjectPlanTemplateReadModel } from '@Quest/ProjectPlanTemplates/readmodels'
    import { ProjectPlanEditorFormSubmitEventPayload, ProjectPlanEditorViewModel } from '@Quest/ProjectPlans/Components/ProjectPlanEditor'

    
export default /*@__PURE__*/_defineComponent({
  __name: 'ManageProjectPlansPage',
  setup(__props) {

    const route = useRoute()
    const workspaceId = computed(() => Number(route.params.workspaceId ?? 0))
    const tchProjectId = computed(() => Number(route.params.tchProjectId ?? 0))
    const projectId = computed(() => String(route.params.projectId ?? ''))

    const projectPlanEditor = shallowReactive(new ProjectPlanEditorViewModel())

    const rm = ref<ManageProjectPlansPageReadModel | null>(null)
    const projectName = computed(() => rm.value?.ProjectName ?? '')
    const portfolioId = computed(() => rm.value?.PortfolioId ?? '')

    const userId = computed(() => rm.value?.UserId)
    const isWorkspaceMember = computed(() => rm.value?.IsWorkspaceMember ?? false)
    const isProjectOwner = computed(() => rm.value?.IsProjectOwner ?? false)
    const isStrategyAdmin = computed(() => rm.value?.IsStrategyAdmin ?? false)

    const activePlan = computed<ProjectPlanReadModel | null>(() => rm.value?.Plans.find(p => p.IsActive) ?? null)
    const backupPlans = computed<ProjectPlanReadModel[]>(() => rm.value?.Plans.filter(p => !p.IsActive) ?? [])
    const planTemplates = computed<ProjectPlanTemplateReadModel[]>(() => rm.value?.PlanTemplates ?? [])

    const {
        runManageProjectPlansPageQueryV1,
        modelManageProjectPlansPageQueryV1,
    } = useManageProjectPlansPageQueryV1(workspaceId, tchProjectId, projectId)
   

    /* ---------------------------------- */
    /* Formatting */
    /* ---------------------------------- */

    function getFormattedDateStr(date: string | null)
    {
        if (!date) return null
        return moment(date).format('MMM D, YYYY')
    }

    function getFormattedTimeStr(date: string | null)
    {
        if (!date) return null
        return moment(date).format('LT')
    }

    /* ---------------------------------- */
    /* Editor actions */
    /* ---------------------------------- */

    function showPlanCreator(template: ProjectPlanTemplateReadModel | null = null)
    {
        projectPlanEditor.showCreator(template)
    }

    function showPlanEditor(plan: ProjectPlanReadModel)
    {
        projectPlanEditor.showEditor(plan)
    }

    /* ---------------------------------- */
    /* Commands */
    /* ---------------------------------- */

    const { invokeCreateProjectPlanCommandV1, onSucceedCreateProjectPlanCommandV1 } =
        useCreateProjectPlanCommandV1(userId, workspaceId, portfolioId, projectId)

    const { invokeUpdateProjectPlanCommandV1, onSucceedUpdateProjectPlanCommandV1 } =
        useUpdateProjectPlanCommandV1(userId, workspaceId, portfolioId, projectId)

    const { invokeCloneProjectPlanCommandV1, onSucceedCloneProjectPlanCommandV1 } =
        useCloneProjectPlanCommandV1(userId, workspaceId, portfolioId, projectId)

    const { invokeDeleteProjectPlanCommandV1, onSucceedDeleteProjectPlanCommandV1 } =
        useDeleteProjectPlanCommandV1(userId, workspaceId, portfolioId, projectId)

    const { invokeSubmitProjectPlanCommandV1, onSucceedSubmitProjectPlanCommandV1 } =
        useSubmitProjectPlanCommandV1(userId, workspaceId, portfolioId, projectId)

    const { invokeUnsubmitProjectPlanCommandV1, onSucceedUnsubmitProjectPlanCommandV1 } =
        useUnsubmitProjectPlanCommandV1(userId, workspaceId, portfolioId, projectId)

    const { invokeUpdateProjectActivePlanCommandV1, onSucceedUpdateProjectActivePlanCommandV1 } =
        useUpdateProjectActivePlanCommandV1(userId, workspaceId, portfolioId, projectId)

    const { invokeCreateEnterpriseTemplateFromProjectPlanCommandV1, onSucceedCreateEnterpriseTemplateFromProjectPlanCommandV1 } =
        useCreateEnterpriseTemplateFromProjectPlanCommandV1(userId, workspaceId, portfolioId, projectId)

    const { invokeCreatePlanFromTemplateCommandV1, onSucceedCreatePlanFromTemplateCommandV1 } =
        useCreatePlanFromTemplateCommandV1(userId, workspaceId, portfolioId, projectId)

    const {
        invokeExportProjectPlanCommandV1,
        onSucceedExportProjectPlanCommandV1,
        result: resultExportProjectPlanCommandV1
    } = useExportProjectPlanCommandV1(userId, workspaceId, portfolioId, projectId)

    /* ---------------------------------- */
    /* Command handlers */
    /* ---------------------------------- */

    function handleProjectPlanEditorFormSubmit(e: ProjectPlanEditorFormSubmitEventPayload)
    {
        if (!rm.value) return

        if (e.id == null)
        {
            invokeCreateProjectPlanCommandV1({
                Id: guid(),
                PlanName: e.planName,
                DurationInMonths: e.durationInMonths,
                Granularity: e.granularity,
                Denomination: e.denomination,
                SubmissionDueDateIsoString: e.submissionDueDateIsoString
            })
        }
        else
        {
            invokeUpdateProjectPlanCommandV1({
                Id: e.id,
                PlanName: e.planName,
                DurationInMonths: e.durationInMonths,
                Granularity: e.granularity,
                Denomination: e.denomination,
                SubmissionDueDateIsoString: e.submissionDueDateIsoString
            })
        }
    }

    function handleSubmitProjectPlanCommand(plan: ProjectPlanReadModel)
    {
        if (confirm(`Are you sure you want to submit the plan: ${plan.Name}`))
        {
            invokeSubmitProjectPlanCommandV1({ Id: plan.Id })
        }
    }

    function handleUnsubmitProjectPlanCommand(plan: ProjectPlanReadModel)
    {
        if (confirm(`Are you sure you want unsubmit the plan: ${plan.Name}`))
        {
            invokeUnsubmitProjectPlanCommandV1({ Id: plan.Id })
        }
    }

    function handleDeleteProjectPlanCommand(plan: ProjectPlanReadModel)
    {
        if (confirm(`Are you sure you want to delete: ${plan.Name}`))
        {
            invokeDeleteProjectPlanCommandV1({
                Id: plan.Id,
            })
        }
    }

    function handleCloneProjectPlanCommand(plan: ProjectPlanReadModel)
    {
        invokeCloneProjectPlanCommandV1({
            Id: guid(),
            SourcePlanId: plan.Id,
            ClonePlanName: generateName(plan.Name)
        })
    }

    function handleUpdateProjectActivePlanCommand(plan: ProjectPlanReadModel)
    {
        invokeUpdateProjectActivePlanCommandV1({
            ProjectPlanId: plan.Id
        })
    }

    function handleExportProjectPlanCommand(plan: ProjectPlanReadModel)
    {
        invokeExportProjectPlanCommandV1({
            Id: plan.Id,
        })
    }

    function handleCreateEnterpriseTemplateFromProjectPlanCommand(plan: ProjectPlanReadModel)
    {
        if (!isStrategyAdmin.value) return

        invokeCreateEnterpriseTemplateFromProjectPlanCommandV1({
            ProjectPlanId: plan.Id,
            Id: guid(),
            StrategyId: rm.value?.StrategyId,
            Name: generateName("Template"),
            Description: `Template created from project plan ${plan.Name}`
        })
    }

    function handleCreatePlanFromTemplateCommand(template: ProjectPlanTemplateReadModel)
    {
        invokeCreatePlanFromTemplateCommandV1({
            Id: guid(),
            ProjectPlanTemplateId: template.Id,
            PlanName: generateName(template.Name)
        })
    }

    onMounted(() =>
    {
        document.title = 'Project | TransparentChoice'
        runManageProjectPlansPageQueryV1()
    })

    watch(modelManageProjectPlansPageQueryV1, (current) =>
    {
        if (current?.RedirectUrl)
        {
            window.location.replace(current.RedirectUrl)
        }

        if (current)
        {
            rm.value = current
        }
    })


    onSucceedCreateProjectPlanCommandV1(() =>
    {
        projectPlanEditor.close()
        runManageProjectPlansPageQueryV1()
    })

    onSucceedUpdateProjectPlanCommandV1(() =>
    {
        projectPlanEditor.close()
        runManageProjectPlansPageQueryV1()
    })

    onSucceedCloneProjectPlanCommandV1(() =>
    {
        runManageProjectPlansPageQueryV1()
    })

    onSucceedDeleteProjectPlanCommandV1(() =>
    {
        runManageProjectPlansPageQueryV1()
    })

    onSucceedSubmitProjectPlanCommandV1(() =>
    {
        runManageProjectPlansPageQueryV1()
    })

    onSucceedUnsubmitProjectPlanCommandV1(() =>
    {
        runManageProjectPlansPageQueryV1()
    })

    onSucceedUpdateProjectActivePlanCommandV1(() =>
    {
        runManageProjectPlansPageQueryV1()
    })

    onSucceedExportProjectPlanCommandV1(() =>
    {
        if (resultExportProjectPlanCommandV1.value)
        {
            location.href = resultExportProjectPlanCommandV1.value
        }
    })

    onSucceedCreateEnterpriseTemplateFromProjectPlanCommandV1(() =>
    {
        alert("Done");
        runManageProjectPlansPageQueryV1()
    })

    onSucceedCreatePlanFromTemplateCommandV1(() =>
    {
        runManageProjectPlansPageQueryV1()
    })



return (_ctx: any,_cache: any) => {
  const _directive_sanitizedHref = _resolveDirective("sanitizedHref")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(ProjectPlanEditor, {
      viewModel: _unref(projectPlanEditor),
      onFormSubmit: handleProjectPlanEditorFormSubmit
    }, null, 8 /* PROPS */, ["viewModel"]),
    (isWorkspaceMember.value)
      ? (_openBlock(), _createBlock(PortfolioNavigation, {
          key: 0,
          workspaceId: workspaceId.value,
          projectId: tchProjectId.value
        }, null, 8 /* PROPS */, ["workspaceId", "projectId"]))
      : (isProjectOwner.value)
        ? (_openBlock(), _createBlock(Navigation, { key: 1 }))
        : _createCommentVNode("v-if", true),
    (rm.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("h1", _hoisted_4, [
                _withDirectives((_openBlock(), _createElementBlock("a", _hoisted_5, [
                  _createTextVNode(_toDisplayString(projectName.value) + " ", 1 /* TEXT */),
                  _cache[8] || (_cache[8] = _createElementVNode("i", { class: "fa fa-external-link-alt project-title-icon" }, null, -1 /* CACHED */))
                ])), [
                  [_directive_sanitizedHref, `/#/portfolio/alternative/dashboard/${workspaceId.value}/${tchProjectId.value}/${projectId.value}`]
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _cache[11] || (_cache[11] = _createElementVNode("button", {
                  class: "btn btn-outline-secondary mr-1",
                  type: "button",
                  "data-toggle": "dropdown",
                  style: {"padding":"0.7em 2em"}
                }, " Create a business case ", -1 /* CACHED */)),
                _createElementVNode("div", _hoisted_8, [
                  _cache[9] || (_cache[9] = _createElementVNode("h6", { class: "dropdown-header" }, "Business case templates", -1 /* CACHED */)),
                  (!planTemplates.value.length)
                    ? (_openBlock(), _createElementBlock("small", _hoisted_9, " You don't have any templates yet. "))
                    : _createCommentVNode("v-if", true),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(planTemplates.value, (t) => {
                    return (_openBlock(), _createElementBlock("a", {
                      class: "dropdown-item",
                      key: t.Id,
                      onClick: ($event: any) => (handleCreatePlanFromTemplateCommand(t))
                    }, _toDisplayString(t.Name), 9 /* TEXT, PROPS */, _hoisted_10))
                  }), 128 /* KEYED_FRAGMENT */)),
                  _cache[10] || (_cache[10] = _createElementVNode("div", { class: "dropdown-divider" }, null, -1 /* CACHED */)),
                  _createElementVNode("a", {
                    class: "dropdown-item",
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (showPlanCreator()))
                  }, "Custom business case")
                ])
              ])
            ])
          ]),
          _cache[34] || (_cache[34] = _createElementVNode("hr", null, null, -1 /* CACHED */)),
          (rm.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                (rm.value.Plans.length === 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                      _createElementVNode("div", _hoisted_13, [
                        _cache[14] || (_cache[14] = _createElementVNode("button", {
                          class: "btn btn-success",
                          type: "button",
                          "data-toggle": "dropdown",
                          style: {"padding":"0.7em 2em"}
                        }, " Create a business case ", -1 /* CACHED */)),
                        _createElementVNode("div", _hoisted_14, [
                          _cache[12] || (_cache[12] = _createElementVNode("h6", { class: "dropdown-header" }, "Business case templates", -1 /* CACHED */)),
                          (!planTemplates.value.length)
                            ? (_openBlock(), _createElementBlock("small", _hoisted_15, " You don't have any templates yet. "))
                            : _createCommentVNode("v-if", true),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(planTemplates.value, (t) => {
                            return (_openBlock(), _createElementBlock("a", {
                              class: "dropdown-item",
                              key: t.Id,
                              onClick: ($event: any) => (showPlanCreator(t))
                            }, _toDisplayString(t.Name), 9 /* TEXT, PROPS */, _hoisted_16))
                          }), 128 /* KEYED_FRAGMENT */)),
                          _cache[13] || (_cache[13] = _createElementVNode("div", { class: "dropdown-divider" }, null, -1 /* CACHED */)),
                          _createElementVNode("a", {
                            class: "dropdown-item",
                            onClick: _cache[1] || (_cache[1] = ($event: any) => (showPlanCreator()))
                          }, "Custom business case")
                        ])
                      ])
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_17, [
                      _createElementVNode("table", _hoisted_18, [
                        _cache[33] || (_cache[33] = _createElementVNode("thead", null, [
                          _createElementVNode("tr", { class: "table-secondary" }, [
                            _createElementVNode("th", null, "Active business case"),
                            _createElementVNode("th", {
                              style: {"width":"150px"},
                              class: "text-center"
                            }, "Created"),
                            _createElementVNode("th", {
                              style: {"width":"150px"},
                              class: "text-center"
                            }, "Modified"),
                            _createElementVNode("th", {
                              style: {"width":"150px"},
                              class: "text-center"
                            }, "Activated"),
                            _createElementVNode("th", {
                              style: {"width":"150px"},
                              class: "text-center"
                            }, "Submitted"),
                            _createElementVNode("th", {
                              style: {"width":"150px"},
                              class: "text-center"
                            }, "Submission due"),
                            _createElementVNode("th", { class: "text-center" }, "Duration (months)"),
                            _createElementVNode("th", { class: "text-center" }, "Granularity"),
                            _createElementVNode("th", { class: "text-center" }, "Denomination"),
                            _createElementVNode("th", { style: {"width":"120px"} })
                          ])
                        ], -1 /* CACHED */)),
                        _createElementVNode("tbody", null, [
                          (activePlan.value)
                            ? (_openBlock(), _createElementBlock("tr", _hoisted_19, [
                                _createElementVNode("td", null, [
                                  _withDirectives((_openBlock(), _createElementBlock("a", _hoisted_20, [
                                    _createTextVNode(_toDisplayString(activePlan.value.Name), 1 /* TEXT */)
                                  ])), [
                                    [_directive_sanitizedHref, `/#/q/project/revenues/${workspaceId.value}/${tchProjectId.value}/${projectId.value}/${activePlan.value.Id}`]
                                  ])
                                ]),
                                _createElementVNode("td", _hoisted_21, [
                                  _createElementVNode("span", null, _toDisplayString(getFormattedDateStr(activePlan.value.CreatedDate)), 1 /* TEXT */),
                                  _cache[15] || (_cache[15] = _createElementVNode("br", null, null, -1 /* CACHED */)),
                                  _createElementVNode("small", null, _toDisplayString(getFormattedTimeStr(activePlan.value.CreatedDate)), 1 /* TEXT */)
                                ]),
                                _createElementVNode("td", _hoisted_22, [
                                  _createElementVNode("span", null, _toDisplayString(getFormattedDateStr(activePlan.value.ModifiedDate)), 1 /* TEXT */),
                                  _cache[16] || (_cache[16] = _createElementVNode("br", null, null, -1 /* CACHED */)),
                                  _createElementVNode("small", null, _toDisplayString(getFormattedTimeStr(activePlan.value.ModifiedDate)), 1 /* TEXT */)
                                ]),
                                _createElementVNode("td", _hoisted_23, [
                                  _createElementVNode("span", null, _toDisplayString(getFormattedDateStr(activePlan.value.ActivationDate)), 1 /* TEXT */),
                                  _cache[17] || (_cache[17] = _createElementVNode("br", null, null, -1 /* CACHED */)),
                                  _createElementVNode("small", null, _toDisplayString(getFormattedTimeStr(activePlan.value.ActivationDate)), 1 /* TEXT */)
                                ]),
                                _createElementVNode("td", _hoisted_24, [
                                  _createElementVNode("span", null, _toDisplayString(getFormattedDateStr(activePlan.value.SubmissionDate)), 1 /* TEXT */),
                                  _cache[18] || (_cache[18] = _createElementVNode("br", null, null, -1 /* CACHED */)),
                                  _createElementVNode("small", null, _toDisplayString(getFormattedTimeStr(activePlan.value.SubmissionDate)), 1 /* TEXT */)
                                ]),
                                _createElementVNode("td", _hoisted_25, [
                                  _createElementVNode("span", null, _toDisplayString(getFormattedDateStr(activePlan.value.SubmissionDueDate)), 1 /* TEXT */),
                                  _cache[19] || (_cache[19] = _createElementVNode("br", null, null, -1 /* CACHED */)),
                                  _createElementVNode("small", null, _toDisplayString(getFormattedTimeStr(activePlan.value.SubmissionDueDate)), 1 /* TEXT */)
                                ]),
                                _createElementVNode("td", _hoisted_26, _toDisplayString(activePlan.value.Duration), 1 /* TEXT */),
                                _createElementVNode("td", _hoisted_27, _toDisplayString(activePlan.value.Granularity), 1 /* TEXT */),
                                _createElementVNode("td", _hoisted_28, _toDisplayString(activePlan.value.Denomination), 1 /* TEXT */),
                                _createElementVNode("td", null, [
                                  _createElementVNode("div", _hoisted_29, [
                                    _cache[23] || (_cache[23] = _createElementVNode("button", {
                                      type: "button",
                                      class: "btn btn-outline-secondary dropdown-toggle",
                                      "data-toggle": "dropdown"
                                    }, "Actions", -1 /* CACHED */)),
                                    _createElementVNode("div", _hoisted_30, [
                                      _createCommentVNode(" Settings "),
                                      _createElementVNode("button", {
                                        class: "dropdown-item",
                                        disabled: activePlan.value.IsSubmitted,
                                        onClick: _cache[2] || (_cache[2] = ($event: any) => (showPlanEditor(activePlan.value)))
                                      }, " Settings ", 8 /* PROPS */, _hoisted_31),
                                      _cache[20] || (_cache[20] = _createElementVNode("div", { class: "dropdown-divider" }, null, -1 /* CACHED */)),
                                      _createCommentVNode(" Submit (only if not yet submitted) "),
                                      (!activePlan.value.IsSubmitted)
                                        ? (_openBlock(), _createElementBlock("button", {
                                            key: 0,
                                            class: "dropdown-item",
                                            onClick: _cache[3] || (_cache[3] = ($event: any) => (handleSubmitProjectPlanCommand(activePlan.value)))
                                          }, " Submit "))
                                        : _createCommentVNode("v-if", true),
                                      _createCommentVNode(" Unsubmit (only if submitted and user is a workspace member) "),
                                      (activePlan.value.IsSubmitted && isWorkspaceMember.value)
                                        ? (_openBlock(), _createElementBlock("button", {
                                            key: 1,
                                            class: "dropdown-item",
                                            onClick: _cache[4] || (_cache[4] = ($event: any) => (handleUnsubmitProjectPlanCommand(activePlan.value)))
                                          }, " Unsubmit "))
                                        : _createCommentVNode("v-if", true),
                                      _createCommentVNode(" Other actions "),
                                      _createElementVNode("button", {
                                        class: "dropdown-item",
                                        onClick: _cache[5] || (_cache[5] = ($event: any) => (handleCloneProjectPlanCommand(activePlan.value)))
                                      }, " Clone "),
                                      _createElementVNode("a", {
                                        class: "dropdown-item",
                                        onClick: _cache[6] || (_cache[6] = ($event: any) => (handleExportProjectPlanCommand(activePlan.value)))
                                      }, " Download as xls "),
                                      _createElementVNode("button", {
                                        class: "dropdown-item",
                                        title: "Available to enterprise admin",
                                        disabled: !isStrategyAdmin.value,
                                        onClick: _cache[7] || (_cache[7] = ($event: any) => (handleCreateEnterpriseTemplateFromProjectPlanCommand(activePlan.value)))
                                      }, " Save as template ", 8 /* PROPS */, _hoisted_32),
                                      _cache[21] || (_cache[21] = _createElementVNode("div", { class: "dropdown-divider" }, null, -1 /* CACHED */)),
                                      _cache[22] || (_cache[22] = _createElementVNode("button", {
                                        class: "dropdown-item",
                                        disabled: ""
                                      }, " Delete ", -1 /* CACHED */))
                                    ])
                                  ])
                                ])
                              ]))
                            : _createCommentVNode("v-if", true),
                          (backupPlans.value.length > 0)
                            ? (_openBlock(), _createElementBlock("tr", _hoisted_33, [...(_cache[24] || (_cache[24] = [
                                _createElementVNode("td", { colspan: "10" }, "Backup business cases", -1 /* CACHED */)
                              ]))]))
                            : _createCommentVNode("v-if", true),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(backupPlans.value, (plan) => {
                            return (_openBlock(), _createElementBlock("tr", {
                              key: plan.Id
                            }, [
                              _createElementVNode("td", null, [
                                _withDirectives((_openBlock(), _createElementBlock("a", _hoisted_34, [
                                  _createTextVNode(_toDisplayString(plan.Name), 1 /* TEXT */)
                                ])), [
                                  [_directive_sanitizedHref, `/#/q/project/revenues/${workspaceId.value}/${tchProjectId.value}/${projectId.value}/${plan.Id}`]
                                ])
                              ]),
                              _createElementVNode("td", _hoisted_35, [
                                _createElementVNode("span", null, _toDisplayString(getFormattedDateStr(plan.CreatedDate)), 1 /* TEXT */),
                                _cache[25] || (_cache[25] = _createElementVNode("br", null, null, -1 /* CACHED */)),
                                _createElementVNode("small", null, _toDisplayString(getFormattedTimeStr(plan.CreatedDate)), 1 /* TEXT */)
                              ]),
                              _createElementVNode("td", _hoisted_36, [
                                _createElementVNode("span", null, _toDisplayString(getFormattedDateStr(plan.ModifiedDate)), 1 /* TEXT */),
                                _cache[26] || (_cache[26] = _createElementVNode("br", null, null, -1 /* CACHED */)),
                                _createElementVNode("small", null, _toDisplayString(getFormattedTimeStr(plan.ModifiedDate)), 1 /* TEXT */)
                              ]),
                              _createElementVNode("td", _hoisted_37, [
                                _createElementVNode("span", null, _toDisplayString(getFormattedDateStr(plan.ActivationDate)), 1 /* TEXT */),
                                _cache[27] || (_cache[27] = _createElementVNode("br", null, null, -1 /* CACHED */)),
                                _createElementVNode("small", null, _toDisplayString(getFormattedTimeStr(plan.ActivationDate)), 1 /* TEXT */)
                              ]),
                              _createElementVNode("td", _hoisted_38, [
                                _createElementVNode("span", null, _toDisplayString(getFormattedDateStr(plan.SubmissionDate)), 1 /* TEXT */),
                                _cache[28] || (_cache[28] = _createElementVNode("br", null, null, -1 /* CACHED */)),
                                _createElementVNode("small", null, _toDisplayString(getFormattedTimeStr(plan.SubmissionDate)), 1 /* TEXT */)
                              ]),
                              _createElementVNode("td", _hoisted_39, [
                                _createElementVNode("span", null, _toDisplayString(getFormattedDateStr(plan.SubmissionDueDate)), 1 /* TEXT */),
                                _cache[29] || (_cache[29] = _createElementVNode("br", null, null, -1 /* CACHED */)),
                                _createElementVNode("small", null, _toDisplayString(getFormattedTimeStr(plan.SubmissionDueDate)), 1 /* TEXT */)
                              ]),
                              _createElementVNode("td", _hoisted_40, _toDisplayString(plan.Duration), 1 /* TEXT */),
                              _createElementVNode("td", _hoisted_41, _toDisplayString(plan.Granularity), 1 /* TEXT */),
                              _createElementVNode("td", _hoisted_42, _toDisplayString(plan.Denomination), 1 /* TEXT */),
                              _createElementVNode("td", null, [
                                _createElementVNode("div", _hoisted_43, [
                                  _cache[32] || (_cache[32] = _createElementVNode("button", {
                                    type: "button",
                                    class: "btn btn-outline-secondary dropdown-toggle",
                                    "data-toggle": "dropdown"
                                  }, "Actions", -1 /* CACHED */)),
                                  _createElementVNode("div", _hoisted_44, [
                                    _createCommentVNode(" Settings "),
                                    _createElementVNode("button", {
                                      class: "dropdown-item",
                                      disabled: plan.IsSubmitted,
                                      onClick: ($event: any) => (showPlanEditor(plan))
                                    }, " Settings ", 8 /* PROPS */, _hoisted_45),
                                    _cache[30] || (_cache[30] = _createElementVNode("div", { class: "dropdown-divider" }, null, -1 /* CACHED */)),
                                    _createCommentVNode(" Submit (only if not yet submitted) "),
                                    (!plan.IsSubmitted)
                                      ? (_openBlock(), _createElementBlock("button", {
                                          key: 0,
                                          class: "dropdown-item",
                                          onClick: ($event: any) => (handleSubmitProjectPlanCommand(plan))
                                        }, " Submit ", 8 /* PROPS */, _hoisted_46))
                                      : _createCommentVNode("v-if", true),
                                    _createCommentVNode(" Unsubmit (only if submitted and user is a workspace member) "),
                                    (plan.IsSubmitted && isWorkspaceMember.value)
                                      ? (_openBlock(), _createElementBlock("button", {
                                          key: 1,
                                          class: "dropdown-item",
                                          onClick: ($event: any) => (handleUnsubmitProjectPlanCommand(plan))
                                        }, " Unsubmit ", 8 /* PROPS */, _hoisted_47))
                                      : _createCommentVNode("v-if", true),
                                    _createCommentVNode(" Other actions "),
                                    _createElementVNode("button", {
                                      class: "dropdown-item",
                                      onClick: ($event: any) => (handleCloneProjectPlanCommand(plan))
                                    }, " Clone ", 8 /* PROPS */, _hoisted_48),
                                    _createElementVNode("button", {
                                      class: "dropdown-item",
                                      onClick: ($event: any) => (handleUpdateProjectActivePlanCommand(plan))
                                    }, " Set as Active ", 8 /* PROPS */, _hoisted_49),
                                    _createElementVNode("a", {
                                      class: "dropdown-item",
                                      onClick: ($event: any) => (handleExportProjectPlanCommand(plan))
                                    }, " Download as xls ", 8 /* PROPS */, _hoisted_50),
                                    _cache[31] || (_cache[31] = _createElementVNode("div", { class: "dropdown-divider" }, null, -1 /* CACHED */)),
                                    _createElementVNode("button", {
                                      class: "dropdown-item",
                                      disabled: plan.IsSubmitted,
                                      onClick: ($event: any) => (handleDeleteProjectPlanCommand(plan))
                                    }, " Delete ", 8 /* PROPS */, _hoisted_51)
                                  ])
                                ])
                              ])
                            ]))
                          }), 128 /* KEYED_FRAGMENT */))
                        ])
                      ])
                    ]))
              ]))
            : _createCommentVNode("v-if", true)
        ]))
      : _createCommentVNode("v-if", true)
  ]))
}
}

})